import { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

export default function DealDevelopmentDialog({ page, onClose }) {
  const dialog = useRef(null)
  useEffect(() => { dialog.current?.showModal() }, [])
  return createPortal(<dialog ref={dialog} className="dp-development-dialog" aria-labelledby="dp-development-title" onCancel={(event) => { event.preventDefault(); onClose() }} onKeyDown={(event) => { if (event.key === 'Escape') event.stopPropagation() }} onClick={(event) => { if (event.target === event.currentTarget) onClose() }}>
    <h2 id="dp-development-title">Página em desenvolvimento</h2>
    <p>{page === 'atualizar-empresa' ? 'A atualização dos dados da empresa pelo CNPJ está em desenvolvimento.' : `Os detalhes ${page === 'empresa' ? 'da empresa' : 'do responsável'} estarão disponíveis em breve.`}</p>
    <button type="button" autoFocus onClick={onClose}>Fechar</button>
  </dialog>, document.body)
}
